{
	"error": {
		"message": "Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente."
	},
	"placeholder": "Digite sua mensagem...",
	"initialMessage": "Olá, como posso ajudar?"
}
